<template>
  <div class="pagina-margem">
    <div v-if="!mobile" id="base-desktop">
      <div class="row align-center secao-anti-quebra">
        <div
          style="width: 15%"
          class="column justify-center items-center q-pa-sm"
        >
          <q-img
            v-if="logoVendor"
            :src="logoVendor"
            crossorigin="*"
            style="max-width: 180px; max-height: 80px"
            fit="contain"
            @error="onLogoError"
          />
          <q-img
            v-else
            crossorigin="*"
            src="../../../../assets/MULTPEX_VETOR.png"
            style="max-width: 180px; max-height: 80px"
            fit="contain"
          />
        </div>

        <section class="column" style="width: 85%">
          <div class="border row q-mb-sm">
            <div
              class="q-pl-sm text-bold row justify-center items-center"
              style="width: 70%"
            >
              PERMISSÃO PARA TRABALHO
            </div>
            <div class="border-left q-pl-sm text-bold" style="width: 30%">
              Nº:
              {{ pt.ptId ? pt.ptId.toString().padStart(7, "0") : "0000000" }}
            </div>
          </div>

          <div class="border row q-mb-sm">
            <div class="q-pl-sm text-bold" style="width: 50%">
              UNIDADE:
              <span class="text">{{
                $store.state.org.unidadeData?.nome || "N/A"
              }}</span>
            </div>
            <div class="border-left q-pl-sm text-bold" style="width: 50%">
              Nº DE PESSOAS: <span class="text">{{ contarPessoas() }}</span>
            </div>
          </div>

          <div style="width: 100%" class="row">
            <div style="width: 50%" class="row">
              <div style="width: 33.3%" class="column">
                <span
                  class="border-left-rigth q-pl-sm row justify-center text-bold"
                  >Status</span
                >
                <span
                  class="border-left-rigth q-pl-sm row justify-center text-bold"
                  >Emissão</span
                >
                <span
                  class="border-left-rigth q-pl-sm row justify-center text-bold"
                  >Prev. Início</span
                >
                <span
                  class="border-left-rigth q-pl-sm row justify-center text-bold"
                  >Prev. Término</span
                >
                <span v-if="pt.logStatus"
                  ><span
                    v-for="(status, index) in pt.logStatus"
                    :key="index"
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >{{ formatarStatus(status.status) }}</span
                  >
                </span>
              </div>
              <div style="width: 33.3%" class="column">
                <span
                  class="border-left-rigth q-pl-sm row justify-center text-bold"
                  >Data</span
                >
                <span
                  v-if="pt.dataHoraEmissao"
                  class="border-left-rigth q-pl-sm"
                  >{{ formatarData(pt.dataHoraEmissao) }}</span
                >
                <span
                  v-if="pt.dataHoraInicio"
                  class="border-left-rigth q-pl-sm"
                  >{{ formatarData(pt.dataHoraInicio) }}</span
                >
                <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                <span
                  v-if="pt.dataHoraTermino"
                  class="border-left-rigth q-pl-sm"
                  >{{ formatarData(pt.dataHoraTermino) }}</span
                >
                <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                <span v-if="pt.logStatus"
                  ><span
                    v-for="(status, index) in pt.logStatus"
                    :key="index"
                    class="border-left-rigth q-pl-sm row"
                    >{{ formatarData(status.dataHora) }}</span
                  >
                </span>
              </div>
              <div style="width: 33.4%" class="column">
                <span
                  class="border-left-rigth border-top q-pl-sm row justify-center text-bold"
                  >Hora</span
                >
                <span
                  v-if="pt.dataHoraEmissao"
                  class="border-left-rigth q-pl-sm"
                  >{{ formatarHora(pt.dataHoraEmissao) }}</span
                >
                <span
                  v-if="pt.dataHoraInicio"
                  class="border-left-rigth q-pl-sm"
                  >{{ formatarHora(pt.dataHoraInicio) }}</span
                >
                <span
                  v-if="pt.dataHoraTermino"
                  class="border-left-rigth q-pl-sm"
                  >{{ formatarHora(pt.dataHoraTermino) }}</span
                >
                <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                <span v-if="pt.logStatus"
                  ><span
                    v-for="(status, index) in pt.logStatus"
                    :key="index"
                    class="border-left-rigth q-pl-sm row"
                    >{{ formatarHora(status.dataHora) }}</span
                  >
                </span>
              </div>
            </div>
            <div
              style="width: 50%"
              class="border-left border-top border-right q-pl-sm q-pt-md q-pb-md text-bold"
            >
              Descrição do Trabalho:
              <span class="text">{{ pt.descricao }}</span>
            </div>
          </div>

          <div style="width: 100%" class="row">
            <span
              style="width: 50%"
              class="border-left-rigth border-bottom q-pl-sm text-bold"
              >Local: <span class="text">{{ pt.local }}</span></span
            >
            <span
              style="width: 50%"
              class="border-left-rigth border-bottom border-right q-pl-sm text-bold"
              >Emissor: <span class="text">{{ formatarEmissor() }}</span></span
            >
          </div>
        </section>
      </div>
      <div class="row align-center q-pt-md">
        <div v-if="pt.informacoes" style="width: 100%" class="border">
          <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
            <span class="text-bold">Observações Importantes:</span>
            {{ pt.informacoes.observacao }}
          </p>
        </div>

        <div
          style="width: 100%"
          class="row q-mt-sm activity-section secao-anti-quebra"
          v-for="(ptData, index) in pt.respostasAtividades"
          :key="index"
        >
          <section style="width: 100%" class="column">
            <div class="border row justify-center activity-header">
              <p class="row justify-center q-pl-sm text-bold activity-name">
                {{ ptData.nome }}
              </p>
            </div>
            <div class="row border-bottom activity-header">
              <span class="q-pl-sm bg-grey-5 border-left" style="width: 80%"
                >Descrição</span
              >
              <span class="border-left row justify-center" style="width: 10%"
                ><strong>SIM</strong></span
              >
              <span
                class="border-left border-right row justify-center"
                style="width: 10%"
                ><strong>N/A</strong></span
              >
            </div>
            <div class="activity-content">
              <div
                class="row activity-item"
                v-for="(ptRespostas, index) in ptData.respostasPerguntas"
                :key="index"
              >
                <span
                  class="q-pl-sm border-left border-bottom"
                  style="width: 80%"
                >
                  <strong class="q-pl-sm" style="font-size: 14px"
                    >{{ index }} - {{ ptRespostas.descricao }}</strong
                  >
                  <span
                    v-if="ptRespostas.observacao"
                    class="row"
                    style="width: 80%"
                  >
                    <strong>Obs:</strong> {{ ptRespostas.observacao }}
                  </span></span
                >

                <span
                  class="border-left border-bottom row justify-center align"
                  style="width: 10%"
                  ><p
                    style="font-size: 18px"
                    v-if="ptRespostas.resposta == true"
                  >
                    <strong>X</strong>
                  </p></span
                >
                <span
                  class="border-left border-right border-bottom row justify-center align"
                  style="width: 10%"
                  ><p
                    style="font-size: 18px"
                    v-if="ptRespostas.resposta == false"
                  >
                    <strong>X</strong>
                  </p></span
                >
              </div>
            </div>
          </section>
        </div>
      </div>
      <div style="page-break-after: always"></div>
      <div class="row align-center q-pt-md">
        <div v-if="pt.informacoes" style="width: 100%" class="border q-mt-md">
          <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
            <span class="text-bold">Área de Trabalho:</span>
            {{ pt.informacoes.areaTrabalho }}
          </p>
        </div>

        <div
          v-if="pt.informacoes"
          style="width: 100%"
          class="row justify-between q-mt-md"
        >
          <p style="width: 40%" class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border">
            <span
              ><span class="text-bold">Recomendações:</span>
              {{ pt.informacoes.recomendacao }}</span
            >
          </p>

          <p style="width: 58%" class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border">
            <span v-if="pt.informacoes"
              ><span class="text-bold">Outras Medidas:</span>
              {{ pt.informacoes.outrasMedidas }}</span
            >
          </p>
        </div>

        <div style="width: 100%" class="border q-mt-md">
          <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
            <span class="text-bold">Observações:</span> As pessoas
            <span class="color">executantes</span> que assinam esta seção estão
            de acordo com as disposições previstas nesta permissão, compreendem
            as suas responsabilidades e garantem que vão
            <span class="text-bold">executar</span> as atividades.
          </p>
        </div>

        <section
          style="width: 100%"
          class="border bg-deep-purple-1 row justify-center q-mt-md"
        >
          <p class="text-bold" style="font-size: 14px">Pessoas Executantes</p>
        </section>

        <section
          style="width: 50%"
          class="column border-top border-right border-left q-mt-md"
          v-for="(executante, index) in pt.executantes"
          :key="index"
        >
          <div class="row">
            <p
              class="row align text-bold border-bottom q-pl-sm border-right bg-deep-purple-1"
              style="width: 60%"
            >
              <span class="row col-12 items-center">
                <q-icon name="person" class="q-pr-sm" />
                Nome:
                <span class="q-pl-sm">{{ executante.nome }}</span>
              </span>
              <span class="row col-12 items-center">
                <q-icon name="how_to_reg" class="q-pr-sm" />
                Matricula:
                <span class="q-pl-sm">{{ executante.matricula }}</span>
              </span>
              <span class="row col-12 items-center">
                <q-icon name="business" class="q-pr-sm" />
                Empresa:
                <span class="q-pl-sm">{{ executante.empresa }}</span>
              </span>
            </p>
            <p
              class="row align q-pl-sm text-bold border-bottom"
              style="width: 40%"
            >
              <strong>Função:</strong>
              <span class="q-pl-sm">{{ executante.cargo }}</span>
            </p>
          </div>
          <span
            class="column signature-container"
            v-for="(assinatura, index) in executante.assinaturas"
            :key="index"
          >
            <p class="q-pl-sm border-bottom text-bold signature-field">
              Ass PT: {{ assinatura.atividadeNome }}

              <img
                v-if="
                  assinatura.assinaturaTipo == 'manual' ||
                  assinatura.assinaturaTipo == 'biometria'
                "
                class="signature-img q-pl-md"
                @click="getImg"
                :src="
                  assinatura.assinaturaTipo === 'biometria' &&
                  assinatura.assinaturaUrlAssinada
                    ? assinatura.assinaturaUrlAssinada
                    : assinatura.assinatura
                "
                alt=""
                crossorigin="*"
              />
              <img
                v-if="
                  assinatura.assinaturaTipo == 'facial' &&
                  assinatura.assinaturaUrlAssinada
                "
                class="signature-img q-pl-md"
                @click="getImg"
                :src="assinatura.assinaturaUrlAssinada"
                alt=""
                crossorigin="*"
              />
              <span
                v-else-if="
                  assinatura.assinaturaTipo == 'facial' &&
                  !assinatura.assinaturaUrlAssinada
                "
                class="text-bold column justify-center signature-text"
              >
                <span>Biometria Facial</span>
              </span>
            </p>
          </span>
        </section>
      </div>

      <section class="column secao-anti-quebra">
        <section
          style="width: 100%; margin-top: 40px; margin-bottom: -15px"
          class="border row justify-center q-mt-md bg-deep-purple-1"
        >
          <p class="text-bold" style="font-size: 14px">
            Assinaturas Responsáveis
          </p>
        </section>
        <div class="row align-center q-pt-lg assinatura-responsaveis-wrap">
          <main
            class="assinatura-responsavel-card"
            v-for="(responsavel, index) in pt.responsaveis"
            :key="index"
          >
            <div class="border signature-card q-ma-sm">
              <div style="width: 100%" class="row">
                <div style="width: 100%" class="column">
                  <section
                    v-if="responsavel.assinaturas"
                    class="column justify-center align content signature-container"
                    style="min-height: 220px"
                  >
                    <img
                      v-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'manual' ||
                        responsavel.assinaturas[0].assinaturaTipo ==
                          'biometrica' ||
                        responsavel.assinaturas[0].assinaturaTipo == 'biometria'
                      "
                      class="signature-img"
                      @click="getImg"
                      :src="
                        (responsavel.assinaturas[0].assinaturaTipo ===
                          'biometrica' ||
                          responsavel.assinaturas[0].assinaturaTipo ===
                            'biometria') &&
                        responsavel.assinaturas[0].assinaturaUrlAssinada
                          ? responsavel.assinaturas[0].assinaturaUrlAssinada
                          : responsavel.assinaturas[0].assinatura
                      "
                      alt=""
                      crossorigin="*"
                    />
                    <img
                      v-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'facial' &&
                        responsavel.assinaturas[0].assinaturaUrlAssinada
                      "
                      class="signature-img"
                      @click="getImg"
                      :src="responsavel.assinaturas[0].assinaturaUrlAssinada"
                      alt=""
                      crossorigin="*"
                    />
                    <div
                      v-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'facial' &&
                        responsavel.assinaturas[0].assinaturaUrlAssinada
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Biometria Facial</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'facial' &&
                        !responsavel.assinaturas[0].assinaturaUrlAssinada
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Biometria Facial</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo ==
                          'biometrica' ||
                        responsavel.assinaturas[0].assinaturaTipo == 'biometria'
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Biometria Digital</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'cracha'
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Autenticado por Crachá</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'manual'
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: 80px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        font-size: 14px !important;
                      "
                    >
                      <span>Assinado em Tela</span>
                    </div>
                    <div
                      v-else
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: 80px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        font-size: 14px !important;
                      "
                    >
                      <span>Assinado Eletrônicamente</span>
                    </div>
                  </section>
                  <p
                    class="text-bold column justify-center align"
                    style="text-align: center"
                  >
                    Assinatura
                    <br />
                    ({{ responsavel.tipo }})
                  </p>
                </div>
              </div>
              <div style="width: 100%" class="row">
                <div style="width: 100%" class="column q-mt-md">
                  <section class="column justify-center align content">
                    <p>
                      <q-icon name="person" class="q-pr-sm" /><strong
                        >Nome: </strong
                      >{{ responsavel.nome }}
                    </p>
                    <p>
                      <q-icon name="how_to_reg" class="q-pr-sm" /><strong
                        >Matricula: </strong
                      >{{ responsavel.matricula }}
                    </p>
                    <p>
                      <q-icon name="business" class="q-pr-sm" /><strong
                        >Empresa: </strong
                      >{{
                        responsavel.tipo == "emissor"
                          ? pt.empresa
                          : responsavel.empresa
                      }}
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </main>
        </div>

        <div class="q-mt-md">
          <p v-if="pt.informacoes" class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
            <span class="color">AVISO!</span> {{ pt.informacoes.aviso }}
          </p>
        </div>

        <div
          v-if="pt.detalhesCancelamento"
          style="width: 100%"
          class="row justify-between q-mt-md"
        >
          <p style="width: 100%" class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border">
            <span
              ><strong
                >Cancelamento da permissão de trabalho (Razões e ações
                necessárias):</strong
              >{{
                pt.detalhesCancelamento
                  ? pt.detalhesCancelamento.acoesNecessarias
                  : ""
              }}</span
            >
          </p>
          <p
            style="width: 100%; margin-top: 10px"
            class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
          >
            <span
              ><strong
                >Cancelamento da permissão de trabalho (Observação):</strong
              >
              {{
                pt.detalhesCancelamento
                  ? pt.detalhesCancelamento.observacao
                  : ""
              }}</span
            >
          </p>
          <p
            style="width: 100%; margin-top: 10px"
            class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
          >
            <span
              ><strong>Cancelamento da permissão de trabalho (Motivo):</strong>
              {{
                pt.detalhesCancelamento ? pt.detalhesCancelamento.motivo : ""
              }}</span
            >
          </p>
          <p
            style="width: 100%; margin-top: 10px"
            class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
          >
            <span
              ><strong>Observações de encerramento: </strong>
              <span>{{ pt.obsEncerramento }}</span></span
            >
          </p>
        </div>

        <div style="page-break-after: always"></div>
        <div style="width: 100%" class="row q-pt-md secao-anti-quebra">
          <section style="width: 100%" class="column">
            <div class="row">
              <span
                class="row justify-center text-bold q-pl-sm bg-grey-5 border-left border-top border-bottom"
                style="width: 80%"
                >Encerramento</span
              >
              <span
                class="border-left border-top border-bottom row justify-center"
                style="width: 10%"
                ><Strong>SIM</Strong></span
              >
              <span
                class="border-left-rigth border-top border-bottom border-right row justify-center"
                style="width: 10%"
                ><Strong>N/A</Strong></span
              >
            </div>
            <div
              class="row"
              v-for="(ptData, index) in pt.respostasEncerramento"
              :key="index"
            >
              <span
                class="q-pl-sm border-left border-bottom"
                style="width: 80%"
              >
                {{ ptData.pergunta }}
              </span>
              <span
                class="border-left border-bottom row justify-center align"
                style="width: 10%"
                ><p style="font-size: 18px" v-if="ptData.resposta == true">
                  <strong>X</strong>
                </p></span
              >
              <span
                class="border-left border-right border-bottom row justify-center align"
                style="width: 10%"
                ><p style="font-size: 18px" v-if="ptData.resposta == false">
                  <strong>X</strong>
                </p></span
              >
            </div>
          </section>
        </div>

        <div
          class="row align-center q-pt-md assinatura-responsaveis-wrap secao-anti-quebra"
        >
          <section
            style="width: 100%; margin-top: 40px"
            class="border row justify-center q-mt-md bg-deep-purple-1 secao-anti-quebra"
          >
            <p class="text-bold" style="font-size: 14px">
              Assinaturas Responsáveis
            </p>
          </section>

          <main
            class="assinatura-responsavel-card"
            v-for="(responsavel, index) in pt.responsaveis"
            :key="index"
          >
            <div class="border signature-card q-ma-sm">
              <div style="width: 100%" class="row">
                <div style="width: 100%" class="column">
                  <section
                    v-if="responsavel.assinaturas"
                    style="width: 100%"
                    class="column"
                  >
                    <section
                      v-if="
                        responsavel.assinaturas[1]
                          ? responsavel.assinaturas[1].atividadeNome ==
                            'encerramento'
                          : ''
                      "
                      class="column justify-center align content signature-container"
                      style="min-height: 220px"
                    >
                      <img
                        v-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'manual' ||
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometrica' ||
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometria'
                        "
                        class="signature-img"
                        @click="getImg"
                        :src="
                          (responsavel.assinaturas[1].assinaturaTipo ===
                            'biometrica' ||
                            responsavel.assinaturas[1].assinaturaTipo ===
                              'biometria') &&
                          responsavel.assinaturas[1].assinaturaUrlAssinada
                            ? responsavel.assinaturas[1].assinaturaUrlAssinada
                            : responsavel.assinaturas[1].assinatura
                        "
                        alt=""
                        crossorigin="*"
                      />
                      <img
                        v-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'facial' &&
                          responsavel.assinaturas[1].assinaturaUrlAssinada
                        "
                        class="signature-img"
                        @click="getImg"
                        :src="responsavel.assinaturas[1].assinaturaUrlAssinada"
                        alt=""
                        crossorigin="*"
                      />
                      <div
                        v-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'facial' &&
                          responsavel.assinaturas[1].assinaturaUrlAssinada
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Biometria Facial</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'facial' &&
                          !responsavel.assinaturas[1].assinaturaUrlAssinada
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Biometria Facial</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometrica' ||
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometria'
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Biometria Digital</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo == 'cracha'
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Autenticado por Crachá</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo == 'manual'
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: 80px !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          font-size: 14px !important;
                        "
                      >
                        <span>Assinado em Tela</span>
                      </div>
                      <div
                        v-else
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: 80px !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          font-size: 14px !important;
                        "
                      >
                        <span>Assinado Eletrônicamente</span>
                      </div>
                    </section>
                    <p
                      class="text-bold column justify-center align"
                      style="text-align: center"
                    >
                      Assinatura
                      <br />
                      ({{ responsavel.tipo }})
                    </p>
                  </section>
                </div>

                <div style="width: 100%" class="row">
                  <div style="width: 100%" class="column q-mt-md">
                    <section class="column justify-center align content">
                      <p>
                        <q-icon name="person" class="q-pr-sm" /><strong
                          >Nome: </strong
                        >{{ responsavel.nome }}
                      </p>
                      <p>
                        <q-icon name="how_to_reg" class="q-pr-sm" /><strong
                          >Matricula: </strong
                        >{{ responsavel.matricula }}
                      </p>
                      <p>
                        <q-icon name="business" class="q-pr-sm" /><strong
                          >Empresa: </strong
                        >{{
                          responsavel.tipo == "emissor"
                            ? pt.empresa
                            : responsavel.empresa
                        }}
                      </p>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </main>

          <div
            style="width: 100%"
            class="row q-mt-md secao-anti-quebra"
            v-if="pt && pt.executantes"
          >
            <div style="width: 100%" class="column">
              <div class="border row justify-center bg-deep-purple-1">
                <p class="row justify-center q-pl-sm text-bold">
                  NOMES DOS EXECUTANTES ENVOLVIDOS NO SERVIÇO
                </p>
              </div>
              <div
                class="border-left border-right border-bottom row justify-center"
              >
                <p class="row justify-center q-pl-sm text-bold">
                  Declaramos que os riscos do trabalho descritos foram
                  informados, estamos cientes e de pleno acordo com as condições
                  estabelecidas para sua liberação. Divulgado as ações em caso
                  emergenciais (Acidente, alarmas, exausto, etc.)?
                </p>
              </div>

              <div class="row border-bottom">
                <span
                  class="q-pl-sm bg-grey-5 border-left text-bold"
                  style="width: 25%"
                  >Nome</span
                >
                <span
                  class="border-left bg-grey-5 text-bold row justify-center"
                  style="width: 15%"
                  >Matrícula</span
                >
                <span
                  class="border-left bg-grey-5 text-bold row justify-center"
                  style="width: 30%"
                  >Função</span
                >
                <span
                  class="border-left bg-grey-5 border-right text-bold row justify-center"
                  style="width: 30%"
                  >Empresa</span
                >
              </div>

              <div
                v-for="(executante, index) in pt.executantes"
                :key="index"
                class="row"
              >
                <span
                  class="q-pl-sm border-left border-bottom"
                  style="width: 25%"
                >
                  {{ executante.nome || "N/A" }}
                </span>
                <span
                  class="border-left border-bottom row justify-center"
                  style="width: 15%"
                >
                  {{ executante.matricula || "N/A" }}
                </span>
                <span
                  class="border-left border-bottom row justify-center"
                  style="width: 30%"
                >
                  {{ executante.cargo || "N/A" }}
                </span>
                <span
                  class="border-left border-right border-bottom row justify-center"
                  style="width: 30%"
                >
                  {{ executante.empresa || "N/A" }}
                </span>
              </div>
            </div>
          </div>

          <template
            v-if="
              (pt.observacoesHistorico && pt.observacoesHistorico.length > 0) ||
              pt.obsAvaliacaoRisco
            "
          >
            <div
              style="width: 100%"
              class="row q-mt-md historico-observacoes-section"
            >
              <section style="width: 100%" class="column">
                <div
                  class="border row justify-center bg-deep-purple-1 historico-observacoes-header"
                >
                  <p
                    class="row justify-center q-pl-sm text-bold"
                    style="font-size: 14px"
                  >
                    Histórico de Observações
                  </p>
                </div>
                <div
                  class="row border-bottom historico-observacoes-table-header"
                >
                  <span
                    class="q-pl-sm bg-grey-5 border-left text-bold justify-center row items-center"
                    style="width: 80%; font-size: 13px"
                    >Observação</span
                  >
                  <span
                    class="border-left row justify-center items-center"
                    style="width: 10%; font-size: 13px; text-align: center"
                    ><strong>Nome Responsável</strong></span
                  >
                  <span
                    class="border-left border-right row justify-center items-center"
                    style="width: 10%; font-size: 13px"
                    ><strong>Data</strong></span
                  >
                </div>

                <template v-if="pt.obsAvaliacaoRisco">
                  <div
                    v-if="typeof pt.obsAvaliacaoRisco === 'string'"
                    class="row historico-observacoes-row"
                  >
                    <span
                      class="q-pl-sm border-left border-bottom"
                      style="width: 80%"
                    >
                      <span class="row col-12 q-pt-md">
                        <strong class="q-mr-xs">Status - Em Aberto: </strong>
                        {{ pt.obsAvaliacaoRisco }}
                      </span>
                    </span>
                    <span
                      class="border-left border-bottom row justify-center items-center"
                      style="width: 10%"
                    >
                      <span style="font-size: 12px; text-align: center">
                        <strong>{{ pt.emissorNome }}</strong>
                      </span>
                    </span>
                    <span
                      class="border-left border-right border-bottom row justify-center items-center"
                      style="width: 10%"
                    >
                      <span style="font-size: 12px; text-align: center">
                        <p>
                          {{
                            pt.logStatus && pt.logStatus[0]
                              ? formatarData(pt.logStatus[0].dataHora)
                              : ""
                          }}
                        </p>
                        <span style="margin-left: 8px">{{
                          pt.logStatus && pt.logStatus[0]
                            ? formatarHora(pt.logStatus[0].dataHora)
                            : ""
                        }}</span>
                      </span>
                    </span>
                  </div>

                  <div
                    v-else-if="Array.isArray(pt.obsAvaliacaoRisco)"
                    v-for="(obs, index) in pt.obsAvaliacaoRisco"
                    :key="`obs-avaliacao-${index}`"
                    class="row historico-observacoes-row"
                  >
                    <span
                      class="q-pl-sm border-left border-bottom"
                      style="width: 80%"
                    >
                      <span class="row col-12 q-py-md">
                        <strong class="q-mr-xs">Status - Em Aberto: </strong>
                        {{ obs.observacao || obs }}
                      </span>
                    </span>
                    <span
                      class="border-left border-bottom row justify-center items-center"
                      style="width: 10%"
                    >
                      <span style="font-size: 12px; text-align: center">
                        <strong>{{ obs.usuarioNome || pt.emissorNome }}</strong>
                      </span>
                    </span>
                    <span
                      class="border-left border-right border-bottom row justify-center items-center"
                      style="width: 10%"
                    >
                      <span style="font-size: 12px; text-align: center">
                        <p>{{ formatarData(obs.dataHora) }}</p>
                        <span style="margin-left: 8px">{{
                          formatarHora(obs.dataHora)
                        }}</span>
                      </span>
                    </span>
                  </div>
                </template>

                <template
                  v-if="
                    pt.observacoesHistorico &&
                    pt.observacoesHistorico.length > 0
                  "
                >
                  <div
                    v-for="(observacao, index) in pt.observacoesHistorico"
                    :key="`historico-${index}`"
                    class="row historico-observacoes-row"
                  >
                    <span
                      class="q-pl-sm border-left border-bottom"
                      style="width: 80%"
                    >
                      <span class="row col-12 q-py-md">
                        <strong class="q-mr-xs"
                          >Observação {{ index + 1 }}:
                        </strong>
                        {{ observacao.observacao }}
                      </span>
                    </span>
                    <span
                      class="border-left border-bottom row justify-center items-center"
                      style="width: 10%"
                      ><span style="font-size: 12px; text-align: center">
                        <strong>{{
                          observacao.usuarioNome || pt.emissorNome
                        }}</strong>
                      </span></span
                    >
                    <span
                      class="border-left border-right border-bottom row justify-center items-center"
                      style="width: 10%"
                      ><span style="font-size: 12px; text-align: center">
                        <p>{{ formatarData(observacao.dataHora) }}</p>
                        <span style="margin-left: 8px">{{
                          formatarHora(observacao.dataHora)
                        }}</span>
                      </span></span
                    >
                  </div>
                </template>

                <template v-if="pt.observacoes && pt.observacoes.length > 0">
                  <div
                    v-for="(observacao, index) in pt.observacoes"
                    :key="`legacy-${index}`"
                    class="row historico-observacoes-row"
                  >
                    <span
                      class="q-pl-sm border-left border-bottom"
                      style="width: 80%"
                    >
                      <span class="row col-12 q-py-md">
                        <strong class="q-mr-xs"
                          >Status -
                          {{
                            observacao.ptStatus == "aguardando_assinaturas"
                              ? "Em Ass.:"
                              : observacao.ptStatus == "iniciado"
                              ? "Iniciado:"
                              : observacao.ptStatus == "encerrado"
                              ? "Encerrado:"
                              : observacao.ptStatus == "cancelado"
                              ? "Cancelado:"
                              : "Em Aberto:"
                          }}</strong
                        >
                        {{ observacao.observacao }}
                      </span></span
                    >

                    <span
                      class="border-left border-bottom row justify-center items-center"
                      style="width: 10%"
                      ><span style="font-size: 12px; text-align: center">
                        <strong>{{ pt.emissorNome }}</strong>
                      </span></span
                    >
                    <span
                      class="border-left border-right border-bottom items-center row justify-center"
                      style="width: 10%"
                    >
                      <span style="font-size: 12px">
                        <p>{{ formatarData(observacao.dataHora) }}</p>
                        <span style="margin-left: 8px">{{
                          formatarHora(observacao.dataHora)
                        }}</span>
                      </span></span
                    >
                  </div>
                </template>
              </section>
            </div>
          </template>
        </div>
      </section>
    </div>

    <div v-else style="width: 100%; overflow: scroll">
      <div id="base-mobile">
        <div class="row align-center">
          <div
            style="width: 15%"
            class="column justify-center items-center q-pa-sm"
          >
            <q-img
              v-if="logoVendor"
              :src="logoVendor"
              crossorigin="*"
              style="max-width: 80px; max-height: 60px"
              fit="contain"
              @error="onLogoError"
            />
            <q-img
              v-else
              crossorigin="*"
              src="../../../../assets/MULTPEX_VETOR.png"
              style="max-width: 80px; max-height: 60px"
              fit="contain"
            />
          </div>

          <section class="column q-pl-md" style="width: 85%">
            <div class="row q-mb-sm">
              <div
                class="border q-pl-sm text-bold row justify-center items-center"
                style="width: 70%"
              >
                PERMISSÃO PARA TRABALHO
              </div>
              <div class="border q-pl-sm text-bold" style="width: 30%">
                Nº:
                {{ pt.ptId ? pt.ptId.toString().padStart(7, "0") : "0000000" }}
              </div>
            </div>

            <div class="row q-mb-sm">
              <div class="border q-pl-sm text-bold" style="width: 40%">
                UNIDADE:
                <span class="text">{{
                  $store.state.org.unidadeData?.nome || "N/A"
                }}</span>
              </div>
              <div class="border q-pl-sm text-bold" style="width: 60%">
                Nº DE PESSOAS: <span class="text">{{ contarPessoas() }}</span>
              </div>
            </div>

            <div style="width: 100%" class="row">
              <div style="width: 50%" class="row">
                <div style="width: 33.3%" class="column">
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >⠀⠀⠀⠀⠀⠀⠀⠀⠀</span
                  >
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >Emissão</span
                  >
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >Prev. Início</span
                  >
                  <span
                    class="border-left-rigth q-pl-sm row justify-center text-bold"
                    >Prev. Término</span
                  >
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row justify-center text-bold"
                      >{{ status.status == "aberto" ? "Em Aberto" : "" }}
                      {{
                        status.status == "aguardando_assinaturas"
                          ? "Em Ass."
                          : ""
                      }}
                      {{ status.status == "iniciado" ? "Iniciado" : ""
                      }}{{ status.status == "encerrado" ? "Encerrado" : "" }}
                      {{ status.status == "finalizado" ? "Finalizado" : "" }}
                      {{
                        status.status == "cancelado" ? "Cancelado" : ""
                      }}</span
                    >
                  </span>
                </div>
                <div style="width: 33.3%" class="column">
                  <span
                    class="border-left-rigth border-top q-pl-sm row justify-center text-bold"
                    >Data</span
                  >
                  <span
                    v-if="pt.dataHoraEmissao"
                    class="border-left-rigth q-pl-sm"
                    >{{
                      pt.dataHoraEmissao
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span
                    v-if="pt.dataHoraInicio"
                    class="border-left-rigth q-pl-sm"
                    >{{
                      pt.dataHoraInicio
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span
                    v-if="pt.dataHoraTermino"
                    class="border-left-rigth q-pl-sm"
                    >{{
                      pt.dataHoraTermino
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row"
                      >{{
                        status.dataHora
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}</span
                    >
                  </span>
                </div>
                <div style="width: 33.4%" class="column">
                  <span
                    class="border-left-rigth border-top q-pl-sm row justify-center text-bold"
                    >Hora</span
                  >
                  <span
                    v-if="pt.dataHoraEmissao"
                    class="border-left-rigth q-pl-sm"
                    >{{ pt.dataHoraEmissao.split(" ")[1] }}</span
                  >
                  <span
                    v-if="pt.dataHoraInicio"
                    class="border-left-rigth q-pl-sm"
                    >{{ pt.dataHoraInicio.split(" ")[1] }}</span
                  >
                  <span
                    v-if="pt.dataHoraTermino"
                    class="border-left-rigth q-pl-sm"
                    >{{ pt.dataHoraTermino.split(" ")[1] }}</span
                  >
                  <span v-else class="border-left-rigth q-pl-sm">Sem Data</span>
                  <span v-if="pt.logStatus"
                    ><span
                      v-for="(status, index) in pt.logStatus"
                      :key="index"
                      class="border-left-rigth q-pl-sm row"
                      >{{ status.dataHora.split(" ")[1] }}</span
                    >
                  </span>
                </div>
              </div>
              <div
                style="width: 50%"
                class="border-left-rigth q-pl-sm q-pt-md q-pb-md text-bold"
              >
                Descrição do Trabalho:
                <span class="text">{{ pt.descricao }}</span>
              </div>
            </div>

            <div style="width: 100%" class="row bottom">
              <span
                style="width: 50%"
                class="border-left-rigth q-pl-sm text-bold"
                >Local: <span class="text">{{ pt.local }}</span></span
              >
              <span
                style="width: 50%"
                class="border-left-rigth q-pl-sm text-bold"
                >Emissor:
                <span class="text">{{ formatarEmissor() }}</span></span
              >
            </div>
          </section>
        </div>
        <div class="row align-center q-pt-md">
          <div v-if="pt.informacoes" style="width: 100%" class="border">
            <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
              <span class="text-bold">Observações Importantes:</span>
              {{ pt.informacoes.observacao }}
            </p>
          </div>

          <div
            style="width: 100%"
            class="row q-mt-sm activity-section"
            v-for="(ptData, index) in pt.respostasAtividades"
            :key="index"
          >
            <section style="width: 100%" class="column">
              <div
                class="border row justify-center bg-deep-purple-1 activity-header"
              >
                <p class="row justify-center q-pl-sm text-bold activity-name">
                  {{ ptData.nome }}
                </p>
              </div>
              <div class="row border-bottom activity-header">
                <span
                  class="q-pl-sm bg-grey-5 border-left border-top"
                  style="width: 80%"
                  >Descrição</span
                >
                <span
                  class="border-left border-top row justify-center"
                  style="width: 10%"
                  ><strong>SIM</strong></span
                >
                <span
                  class="border-left border-right border-top row justify-center"
                  style="width: 10%"
                  ><strong>N/A</strong></span
                >
              </div>
              <div class="activity-content">
                <div
                  class="row activity-item"
                  v-for="(ptRespostas, index) in ptData.respostasPerguntas"
                  :key="index"
                >
                  <span
                    class="q-pl-sm border-left border-bottom"
                    style="width: 80%"
                  >
                    <strong style="font-size: 14px"
                      >{{ index }} - {{ ptRespostas.descricao }}</strong
                    >
                    <span
                      v-if="ptRespostas.observacao"
                      class="row"
                      style="width: 80%"
                    >
                      <strong>Obs:</strong> {{ ptRespostas.observacao }}
                    </span></span
                  >

                  <span
                    class="border-left border-bottom row justify-center align"
                    style="width: 10%"
                    ><p
                      style="font-size: 18px"
                      v-if="ptRespostas.resposta == true"
                    >
                      <strong>X</strong>
                    </p></span
                  >
                  <span
                    class="border-left border-right border-bottom row justify-center align"
                    style="width: 10%"
                    ><p
                      style="font-size: 18px"
                      v-if="ptRespostas.resposta == false"
                    >
                      <strong>X</strong>
                    </p></span
                  >
                </div>
              </div>
            </section>
          </div>
        </div>
        <div style="page-break-after: always"></div>
        <div class="row align-center q-pt-md">
          <div v-if="pt.informacoes" style="width: 100%" class="border q-mt-md">
            <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
              <span class="text-bold">Área de Trabalho:</span>
              {{ pt.informacoes.areaTrabalho }}
            </p>
          </div>

          <div
            v-if="pt.informacoes"
            style="width: 100%"
            class="row justify-between q-mt-md"
          >
            <p
              style="width: 40%"
              class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
            >
              <span
                ><span class="text-bold">Recomendações:</span>
                {{ pt.informacoes.recomendacao }}</span
              >
            </p>

            <p
              style="width: 58%"
              class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
            >
              <span v-if="pt.informacoes"
                ><span class="text-bold">Outras Medidas:</span>
                {{ pt.informacoes.outrasMedidas }}</span
              >
            </p>
          </div>

          <div style="width: 100%" class="border q-mt-md">
            <p class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
              <span class="text-bold">Observações:</span> As pessoas
              <span class="color">executantes</span> que assinam esta seção
              estão de acordo com as disposições previstas nesta permissão,
              compreendem as suas responsabilidades e garantem que vão
              <span class="text-bold">executar</span> as atividades.
            </p>
          </div>

          <section
            style="width: 100%"
            class="border bg-deep-purple-1 row justify-center q-mt-md"
          >
            <p class="text-bold">Pessoas Executantes</p>
          </section>

          <section
            style="width: 50%"
            class="column border-top border-right q-mt-md"
            v-for="(executante, index) in pt.executantes"
            :key="index"
          >
            <div class="row">
              <p
                class="row align text-bold q-pl-sm border-right bg-deep-purple-1"
                style="width: 60%"
              >
                <span class="row col-12 items-center">
                  <q-icon name="person" class="q-pr-sm" />
                  Nome:
                  <span class="q-pl-sm">{{ executante.nome }}</span>
                </span>
                <span class="row col-12 items-center">
                  <q-icon name="how_to_reg" class="q-pr-sm" />
                  Matricula:
                  <span class="q-pl-sm">{{ executante.matricula }}</span>
                </span>
                <span class="row col-12 items-center">
                  <q-icon name="business" class="q-pr-sm" />
                  Empresa:
                  <span class="q-pl-sm">{{ executante.empresa }}</span>
                </span>
              </p>
              <p
                class="row align q-pl-sm text-bold border-bottom"
                style="width: 40%"
              >
                <strong>Função:</strong>
                <span class="q-pl-sm">{{ executante.cargo }}</span>
              </p>
            </div>
            <span
              class="column signature-container"
              v-for="(assinatura, index) in executante.assinaturas"
              :key="index"
            >
              <p
                class="q-pl-sm border-left border-bottom text-bold signature-field"
              >
                Ass PT: {{ assinatura.atividadeNome }}

                <img
                  v-if="
                    assinatura.assinaturaTipo == 'manual' ||
                    assinatura.assinaturaTipo == 'biometria'
                  "
                  class="signature-img q-pl-md"
                  @click="getImg"
                  :src="
                    assinatura.assinaturaTipo === 'biometria' &&
                    assinatura.assinaturaUrlAssinada
                      ? assinatura.assinaturaUrlAssinada
                      : assinatura.assinatura
                  "
                  alt=""
                  crossorigin="*"
                />
                <img
                  v-if="
                    assinatura.assinaturaTipo == 'facial' &&
                    assinatura.assinaturaUrlAssinada
                  "
                  class="signature-img q-pl-md"
                  @click="getImg"
                  :src="assinatura.assinaturaUrlAssinada"
                  alt=""
                  crossorigin="*"
                />
                <span
                  v-else-if="
                    assinatura.assinaturaTipo == 'facial' &&
                    !assinatura.assinaturaUrlAssinada
                  "
                  class="text-bold column justify-center signature-text"
                >
                  <span>Biometria Facial</span>
                </span>
              </p>
            </span>
          </section>
        </div>
        <div class="row align-center q-pt-md">
          <main
            style="width: 33%"
            class="column"
            v-for="(responsavel, index) in pt.responsaveis"
            :key="index"
          >
            <div class="border signature-card q-pa-md q-ma-sm">
              <div style="width: 100%" class="row">
                <div style="width: 100%" class="column">
                  <section
                    v-if="responsavel.assinaturas"
                    class="column justify-center align content signature-container"
                    style="min-height: 120px"
                  >
                    <img
                      v-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'manual' ||
                        responsavel.assinaturas[0].assinaturaTipo ==
                          'biometrica' ||
                        responsavel.assinaturas[0].assinaturaTipo == 'biometria'
                      "
                      class="signature-img"
                      @click="getImg"
                      :src="
                        (responsavel.assinaturas[0].assinaturaTipo ===
                          'biometrica' ||
                          responsavel.assinaturas[0].assinaturaTipo ===
                            'biometria') &&
                        responsavel.assinaturas[0].assinaturaUrlAssinada
                          ? responsavel.assinaturas[0].assinaturaUrlAssinada
                          : responsavel.assinaturas[0].assinatura
                      "
                      alt=""
                      crossorigin="*"
                    />
                    <img
                      v-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'facial' &&
                        responsavel.assinaturas[0].assinaturaUrlAssinada
                      "
                      class="signature-img"
                      @click="getImg"
                      :src="responsavel.assinaturas[0].assinaturaUrlAssinada"
                      alt=""
                      crossorigin="*"
                    />
                    <div
                      v-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'facial' &&
                        responsavel.assinaturas[0].assinaturaUrlAssinada
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Biometria Facial</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'facial' &&
                        !responsavel.assinaturas[0].assinaturaUrlAssinada
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Biometria Facial</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo ==
                          'biometrica' ||
                        responsavel.assinaturas[0].assinaturaTipo == 'biometria'
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Biometria Digital</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'cracha'
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: auto !important;
                      "
                    >
                      <span>Autenticado por Crachá</span>
                    </div>
                    <div
                      v-else-if="
                        responsavel.assinaturas[0].assinaturaTipo == 'manual'
                      "
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: 80px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        font-size: 14px !important;
                      "
                    >
                      <span>Assinado em Tela</span>
                    </div>
                    <div
                      v-else
                      class="text-bold column justify-center signature-text"
                      style="
                        margin-bottom: 9px;
                        margin-top: 9px;
                        height: 80px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        font-size: 14px !important;
                      "
                    >
                      <span>Assinado Eletrônicamente</span>
                    </div>
                  </section>
                  <p class="text-bold column justify-center align q-pt-md">
                    Assinatura ({{ responsavel.tipo }})
                  </p>
                </div>
              </div>

              <div style="width: 100%" class="row">
                <div style="width: 100%" class="column q-mt-lg">
                  <section class="column justify-center align content">
                    <p>
                      <q-icon name="person" class="q-pr-sm" /><strong
                        >Nome: </strong
                      >{{ responsavel.nome }}
                    </p>
                    <p>
                      <q-icon name="how_to_reg" class="q-pr-sm" /><strong
                        >Matricula: </strong
                      >{{ responsavel.matricula }}
                    </p>
                    <p>
                      <q-icon name="business" class="q-pr-sm" /><strong
                        >Empresa: </strong
                      >{{
                        responsavel.tipo == "emissor"
                          ? pt.empresa
                          : responsavel.empresa
                      }}
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </main>
        </div>
        <div style="page-break-after: always"></div>
        <section class="column">
          <div class="border q-mt-md">
            <p v-if="pt.informacoes" class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm">
              <span class="color">AVISO!</span> {{ pt.informacoes.aviso }}
            </p>
          </div>

          <div
            v-if="pt.detalhesCancelamento"
            style="width: 100%"
            class="row justify-between q-mt-md"
          >
            <p
              style="width: 100%"
              class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
            >
              <span
                ><strong
                  >Cancelamento da permissão de trabalho (Razões e ações
                  necessárias):</strong
                >{{
                  pt.detalhesCancelamento
                    ? pt.detalhesCancelamento.acoesNecessarias
                    : ""
                }}</span
              >
            </p>
            <p
              style="width: 100%; margin-top: 10px"
              class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
            >
              <span
                ><strong
                  >Cancelamento da permissão de trabalho (Observação):</strong
                >
                {{
                  pt.detalhesCancelamento
                    ? pt.detalhesCancelamento.observacao
                    : ""
                }}</span
              >
            </p>
            <p
              style="width: 100%; margin-top: 10px"
              class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
            >
              <span
                ><strong
                  >Cancelamento da permissão de trabalho (Motivo):</strong
                >
                {{
                  pt.detalhesCancelamento ? pt.detalhesCancelamento.motivo : ""
                }}</span
              >
            </p>
            <p
              style="width: 100%; margin-top: 10px"
              class="q-pt-sm q-pl-sm q-pr-sm q-pb-sm border"
            >
              <span
                ><strong>Observações de encerramento: </strong>
                <span>{{ pt.obsEncerramento }}</span></span
              >
            </p>
          </div>

          <div style="width: 100%" class="row q-pt-md">
            <section style="width: 100%" class="column">
              <div class="row">
                <span
                  class="row justify-center text-bold q-pl-sm bg-grey-5 border-left border-top border-bottom"
                  style="width: 80%"
                  >Encerramento</span
                >
                <span
                  class="border-left border-top border-bottom row justify-center"
                  style="width: 10%"
                  ><Strong>SIM</Strong></span
                >
                <span
                  class="border-left-rigth border-top row justify-center"
                  style="width: 10%"
                  ><Strong>N/A</Strong></span
                >
              </div>
              <div
                class="row"
                v-for="(ptData, index) in pt.respostasEncerramento"
                :key="index"
              >
                <span
                  class="q-pl-sm border-left border-bottom"
                  style="width: 80%"
                >
                  {{ ptData.pergunta }}
                </span>
                <span
                  class="border-left border-bottom row justify-center align"
                  style="width: 10%"
                  ><p style="font-size: 18px" v-if="ptData.resposta == true">
                    <strong>X</strong>
                  </p></span
                >
                <span
                  class="border-left border-right border-bottom row justify-center align"
                  style="width: 10%"
                  ><p style="font-size: 18px" v-if="ptData.resposta == false">
                    <strong>X</strong>
                  </p></span
                >
              </div>
            </section>
          </div>

          <div class="row align-center q-pt-md">
            <main
              style="width: 33%"
              class="column"
              v-for="(responsavel, index) in pt.responsaveis"
              :key="index"
            >
              <div class="border signature-card q-pa-md q-ma-sm">
                <div style="width: 100%" class="row">
                  <div
                    v-if="responsavel.assinaturas"
                    style="width: 100%"
                    class="column"
                  >
                    <section
                      v-if="
                        responsavel.assinaturas[1]
                          ? responsavel.assinaturas[1].atividadeNome ==
                            'encerramento'
                          : ''
                      "
                      class="column justify-center align content signature-container"
                      style="min-height: 120px"
                    >
                      <img
                        v-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'manual' ||
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometrica' ||
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometria'
                        "
                        class="signature-img"
                        @click="getImg"
                        :src="
                          (responsavel.assinaturas[1].assinaturaTipo ===
                            'biometrica' ||
                            responsavel.assinaturas[1].assinaturaTipo ===
                              'biometria') &&
                          responsavel.assinaturas[1].assinaturaUrlAssinada
                            ? responsavel.assinaturas[1].assinaturaUrlAssinada
                            : responsavel.assinaturas[1].assinatura
                        "
                        alt=""
                        crossorigin="*"
                      />
                      <img
                        v-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'facial' &&
                          responsavel.assinaturas[1].assinaturaUrlAssinada
                        "
                        class="signature-img"
                        @click="getImg"
                        :src="responsavel.assinaturas[1].assinaturaUrlAssinada"
                        alt=""
                        crossorigin="*"
                      />
                      <div
                        v-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'facial' &&
                          responsavel.assinaturas[1].assinaturaUrlAssinada
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Biometria Facial</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'facial' &&
                          !responsavel.assinaturas[1].assinaturaUrlAssinada
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Biometria Facial</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometrica' ||
                          responsavel.assinaturas[1].assinaturaTipo ==
                            'biometria'
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Biometria Digital</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo == 'cracha'
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: auto !important;
                        "
                      >
                        <span>Autenticado por Crachá</span>
                      </div>
                      <div
                        v-else-if="
                          responsavel.assinaturas[1].assinaturaTipo == 'manual'
                        "
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: 80px !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          font-size: 14px !important;
                        "
                      >
                        <span>Assinado em Tela</span>
                      </div>
                      <div
                        v-else
                        class="text-bold column justify-center signature-text"
                        style="
                          margin-bottom: 9px;
                          margin-top: 9px;
                          height: 80px !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          font-size: 14px !important;
                        "
                      >
                        <span>Assinado Eletrônicamente</span>
                      </div>
                    </section>
                    <p class="text-bold column justify-center align q-pt-md">
                      Assinatura ({{ responsavel.tipo }})
                    </p>
                  </div>
                </div>

                <div style="width: 100%" class="row">
                  <div style="width: 100%" class="column q-mt-lg">
                    <section class="column justify-center align content">
                      <p>
                        <q-icon name="person" class="q-pr-sm" /><strong
                          >Nome: </strong
                        >{{ responsavel.nome }}
                      </p>
                      <p>
                        <q-icon name="how_to_reg" class="q-pr-sm" /><strong
                          >Matricula: </strong
                        >{{ responsavel.matricula }}
                      </p>
                      <p>
                        <q-icon name="business" class="q-pr-sm" /><strong
                          >Empresa: </strong
                        >{{
                          responsavel.tipo == "emissor"
                            ? pt.empresa
                            : responsavel.empresa
                        }}
                      </p>
                    </section>
                  </div>
                </div>
              </div>
            </main>
            <div
              v-if="pt.observacoes || pt.obsAvaliacaoRisco"
              style="width: 100%"
              class="row q-mt-md"
            >
              <section style="width: 100%" class="column">
                <div class="border row justify-center bg-deep-purple-1">
                  <p
                    class="row justify-center q-pl-sm text-bold"
                    style="font-size: 14px"
                  >
                    Histórico de Observações
                  </p>
                </div>
                <div class="row border-bottom">
                  <span
                    class="q-pl-sm bg-grey-5 border-left text-bold justify-center row items-center border-top border-bottom"
                    style="width: 80%; font-size: 13px"
                    >Observação</span
                  >
                  <span
                    class="border-left bg-grey-5 row justify-center items-center border-top border-bottom"
                    style="width: 10%; font-size: 13px"
                    ><strong>Nome Responsável</strong></span
                  >
                  <span
                    class="border-left border-right row bg-grey-5 justify-center items-center border-top border-bottom"
                    style="width: 10%; font-size: 13px"
                    ><strong>Data</strong></span
                  >
                </div>
                <div v-if="pt.obsAvaliacaoRisco" class="row">
                  <span
                    class="q-pl-sm border-left border-bottom"
                    style="width: 80%"
                  >
                    <span class="row col-12 q-pt-md">
                      <strong class="q-mr-xs">Status - Em Aberto: </strong>
                      {{ pt.obsAvaliacaoRisco }}
                    </span></span
                  >
                  <span
                    class="border-left border-bottom row justify-center items-center"
                    style="width: 10%"
                    ><span style="font-size: 12px">
                      <strong>{{ pt.emissorNome }}</strong>
                    </span></span
                  >
                  <span
                    class="border-left border-right border-bottom row justify-center"
                    style="width: 10%"
                    ><span style="font-size: 12px">
                      <p>
                        {{
                          pt.logStatus && pt.logStatus[0]
                            ? formatarData(pt.logStatus[0].dataHora)
                            : ""
                        }}
                      </p>
                      <span style="margin-left: 8px">{{
                        pt.logStatus && pt.logStatus[0]
                          ? formatarHora(pt.logStatus[0].dataHora)
                          : ""
                      }}</span>
                    </span></span
                  >
                </div>
                <span v-if="pt.observacoes">
                  <div
                    v-for="(observacao, index) in pt.observacoes"
                    :key="index"
                    class="row"
                  >
                    <span
                      class="q-pl-sm border-left border-bottom"
                      style="width: 80%"
                    >
                      <span class="row col-12 q-py-md">
                        <strong class="q-mr-xs"
                          >Status -
                          {{
                            observacao.ptStatus == "aguardando_assinaturas"
                              ? "Em Ass.:"
                              : ""
                          }}{{
                            observacao.ptStatus == "iniciado"
                              ? "Iniciado:"
                              : ""
                          }}{{
                            observacao.ptStatus == "encerrado"
                              ? "Encerrado:"
                              : ""
                          }}
                          {{
                            observacao.ptStatus == "cancelado"
                              ? "Cancelado:"
                              : ""
                          }}</strong
                        >
                        {{ observacao.observacao }}
                      </span></span
                    >

                    <span
                      class="border-left border-bottom row justify-center items-center"
                      style="width: 10%"
                      ><span style="font-size: 12px">
                        <strong>{{ pt.emissorNome }}</strong>
                      </span></span
                    >
                    <span
                      class="border-left border-right border-bottom items-center row justify-center"
                      style="width: 10%"
                    >
                      <span style="font-size: 12px"
                        ><p>{{ observacao.dataHora.split(" ")[0] }}</p>
                        <span style="margin-left: 8px">{{
                          observacao.dataHora.split(" ")[1]
                        }}</span>
                        <strong></strong> </span
                    ></span>
                  </div>
                </span>
              </section>
            </div>
          </div>
        </section>
      </div>
    </div>

    <ScrollToTopButton />
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ScrollToTopButton from "../../../../components/ScrollToTopButton.vue";

export default {
  components: {
    ScrollToTopButton,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const quasar = useQuasar();
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }

    const ptId = route.params.ptId;
    const pt = ref(false);
    const logoVendor = ref(null);

    const obterLogoVendor = () => {
      try {
        if (store.state.org?.unidadeData?.logo) {
          logoVendor.value = store.state.org.unidadeData.logo;
          return;
        }

        if (store.state.autenticacao?.logo?.logoImpressao) {
          logoVendor.value = store.state.autenticacao.logo.logoImpressao;
          return;
        }

        if (store.state.autenticacao?.logo?.logo) {
          logoVendor.value = store.state.autenticacao.logo.logo;
          return;
        }

        if (store.state.cliente?.logo) {
          logoVendor.value = store.state.cliente.logo;
          return;
        }

        logoVendor.value = null;
      } catch (error) {
        console.error("Erro ao obter logo do vendor:", error);
        logoVendor.value = null;
      }
    };

    const onLogoError = () => {
      console.warn("Erro ao carregar logo do vendor, usando logo padrão");
      logoVendor.value = null;
    };

    const buscarDetalhePt = async () => {
      store.dispatch("pdt/hiddenHeader", false);

      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;

      obterLogoVendor();

      await processarAssinaturas();

      if (mobile.value) {
        zoomOut();
      }
      salvarPdf();
    };

    const obterUrlAssinada = async (urlS3) => {
      try {
        if (urlS3.includes("amazonaws.com")) {
          const testResponse = await fetch(urlS3, { method: "HEAD" }).catch(
            () => null
          );
          if (testResponse && testResponse.ok) {
            return urlS3;
          }
        }

        const api = store.state.autenticacao.api;
        const response = await api.get(
          `/common/file/signedUrl?fileUrl=${encodeURIComponent(urlS3)}`
        );

        let urlAssinada;
        if (response.data.resultado && response.data.resultado.url) {
          urlAssinada = response.data.resultado.url;
        } else if (response.data.url) {
          urlAssinada = response.data.url;
        } else if (
          response.data.resultado &&
          typeof response.data.resultado === "string"
        ) {
          urlAssinada = response.data.resultado;
        } else if (typeof response.data === "string") {
          urlAssinada = response.data;
        } else {
          const jsonStr = JSON.stringify(response.data);
          const urlMatch = jsonStr.match(/https?:\/\/[^\s"]+/);
          if (urlMatch) {
            urlAssinada = urlMatch[0];
          } else {
            urlAssinada = urlS3;
          }
        }

        return urlAssinada;
      } catch (error) {
        console.error("Erro ao obter URL assinada:", error);
        return urlS3;
      }
    };

    const processarAssinaturas = async () => {
      if (!pt.value) return;

      if (pt.value.executantes && pt.value.executantes.length > 0) {
        for (const executante of pt.value.executantes) {
          if (executante.assinaturas && executante.assinaturas.length > 0) {
            for (const assinatura of executante.assinaturas) {
              if (
                (assinatura.assinaturaTipo === "facial" ||
                  assinatura.assinaturaTipo === "biometria" ||
                  assinatura.assinaturaTipo === "biometrica") &&
                assinatura.assinatura
              ) {
                try {
                  const urlAssinada = await obterUrlAssinada(
                    assinatura.assinatura
                  );
                  assinatura.assinaturaUrlAssinada = urlAssinada;
                } catch (error) {
                  console.error("Erro ao obter URL assinada:", error);
                }
              }
            }
          }
        }
      }

      if (pt.value.responsaveis && pt.value.responsaveis.length > 0) {
        for (const responsavel of pt.value.responsaveis) {
          if (responsavel.assinaturas && responsavel.assinaturas.length > 0) {
            for (const assinatura of responsavel.assinaturas) {
              if (
                (assinatura.assinaturaTipo === "facial" ||
                  assinatura.assinaturaTipo === "biometria" ||
                  assinatura.assinaturaTipo === "biometrica") &&
                assinatura.assinatura
              ) {
                try {
                  const urlAssinada = await obterUrlAssinada(
                    assinatura.assinatura
                  );
                  assinatura.assinaturaUrlAssinada = urlAssinada;
                } catch (error) {
                  console.error("Erro ao obter URL assinada:", error);
                }
              }
            }
          }
        }
      }
    };

    const zoomOut = () => {
      const content = document.getElementById("base-mobile");
      content.style.transform = "scale(0.9)";
      content.style.width = `300%`;
      content.style.height = `100%`;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const centerX = (windowWidth - content.clientWidth) / 2;
      const centerY = (windowHeight - content.clientHeight) / 2;

      content.style.transformOrigin = "top left";
      content.style.left = centerX + "px";
      content.style.top = centerY + "px";
    };

    const salvarPdf = async () => {
      if (pt.value.executantes.length > 0) {
        pt.value.executantes.forEach((executante) => {
          if (executante.assinaturas.length > 0) {
            executante.assinaturas.forEach((assinatura) => {
              if (assinatura.url != null) {
                const imagem = new Image();
                imagem.src = assinatura.url;
                imagem.onload = function () {};
                imagem.onerror = function () {
                  console.error("Erro ao pré-carregar a imagem");
                };
              }
            });
          }
        });
      }
      if (pt.value.responsaveis.length > 0) {
        pt.value.responsaveis.forEach((responsavel) => {
          if (responsavel.assinaturas.length > 0) {
            responsavel.assinaturas.forEach((assinatura) => {
              if (assinatura.url != null) {
                const imagem = new Image();
                imagem.src = assinatura.url;
                imagem.onload = function () {};
                imagem.onerror = function () {
                  console.error("Erro ao pré-carregar a imagem");
                };
              }
            });
          }
        });
      }
      quasar.notify({
        message: "Aguarde enquanto o PDF é gerado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      setTimeout(async () => {
        let data = document.getElementById(
          mobile.value ? "base-mobile" : "base-desktop"
        );
        var hoje = new Date();
        let dataGerado = `${hoje.getDate().toString().padStart(2, "0")}/${(
          hoje.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${hoje.getFullYear()} ${hoje
          .getHours()
          .toString()
          .padStart(2, "0")}:${hoje.getMinutes().toString().padStart(2, "0")}`;

        const doc = new jsPDF("p", "mm", "a4");
        const sections = data.querySelectorAll(".secao-anti-quebra");

        const A4_WIDTH_MM = 210;
        const A4_HEIGHT_MM = 297;
        const MARGIN_MM = 10;
        const contentWidthMM = A4_WIDTH_MM - MARGIN_MM * 2;
        const contentHeightMM = A4_HEIGHT_MM - MARGIN_MM * 2;

        let cursorY = MARGIN_MM;
        let pageCount = 1;

        for (const section of sections) {
          const canvas = await html2canvas(section, {
            useCORS: true,
            scale: 2,
          });

          const imgData = canvas.toDataURL("image/jpeg", 0.95);
          const sectionHeightMM =
            (canvas.height * contentWidthMM) / canvas.width;

          if (
            cursorY > MARGIN_MM &&
            cursorY + sectionHeightMM > contentHeightMM
          ) {
            doc.addPage();
            pageCount++;
            cursorY = MARGIN_MM;
          }

          doc.addImage(
            imgData,
            "JPEG",
            MARGIN_MM,
            cursorY,
            contentWidthMM,
            sectionHeightMM
          );
          cursorY += sectionHeightMM + 2;
        }

        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setFontSize(10);
          doc.text(
            `${i}/${pageCount}`,
            A4_WIDTH_MM - MARGIN_MM,
            A4_HEIGHT_MM - MARGIN_MM / 2,
            { align: "right" }
          );
        }
        doc.save(`impressao_pt_${pt.value.ptId}_${dataGerado}`);
      }, 500);
    };

    const contarPessoas = () => {
      if (!pt.value) return 0;
      let totalPessoas = 0;

      if (pt.value.executantes && pt.value.executantes.length > 0) {
        totalPessoas += pt.value.executantes.length;
      }

      if (pt.value.responsaveis && pt.value.responsaveis.length > 0) {
        totalPessoas += pt.value.responsaveis.length;
      }
      return totalPessoas;
    };

    const formatarEmissor = () => {
      if (!pt.value) return "";

      const nome = pt.value.emissorNome || "";
      const matricula = pt.value.emissorMatricula || "";

      if (nome && matricula) {
        return `${nome} - ${matricula}`;
      } else if (nome) {
        return nome;
      } else if (matricula) {
        return matricula;
      }

      return "N/A";
    };

    const formatarStatus = (status) => {
      const statusMap = {
        aberto: "Em Aberto",
        aguardando_assinaturas: "Em Ass.",
        iniciado: "Iniciado",
        encerrado: "Encerrado",
        finalizado: "Finalizado",
        cancelado: "Cancelado",
      };

      return statusMap[status] || status;
    };

    const formatarData = (dataHora) => {
      if (!dataHora) return "";
      return dataHora.split(" ")[0].split("-").reverse().join("/");
    };

    const formatarHora = (dataHora) => {
      if (!dataHora) return "";
      return dataHora.split(" ")[1] || "";
    };

    onMounted(() => {
      obterLogoVendor();
      buscarDetalhePt();
    });

    return {
      ptId,
      pt,
      logoVendor,
      buscarDetalhePt,
      mobile,
      contarPessoas,
      formatarEmissor,
      formatarStatus,
      formatarData,
      formatarHora,
      onLogoError,
    };
  },
};
</script>
<style scoped>
.assinatura-responsaveis-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  page-break-inside: avoid;
  break-inside: avoid;
}

.assinatura-responsavel-card {
  flex: 1 1 300px;
  max-width: 32%;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  page-break-inside: avoid;
  break-inside: avoid;
  margin-bottom: 12px;
}

.secao-anti-quebra {
  margin-bottom: 10px;
  page-break-inside: avoid;
}

@media print {
  .assinatura-responsaveis-wrap {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }
  .assinatura-responsavel-card {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    max-width: 32% !important;
    min-width: 220px !important;
    margin-bottom: 8px !important;
  }

  .secao-anti-quebra {
    margin-bottom: 10px;
    page-break-inside: avoid;
  }
}

.border {
  border: 1px solid black;
}

.border-left {
  border-left: 1px solid black;
}

.border-top {
  border-top: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.border-left-rigth {
  border-left: 1px solid black;
  border-top: 1px solid black;
}

.flex {
  display: flex;
  justify-content: center;
}

.align {
  align-items: center;
}

.text {
  font-weight: normal;
}

.color {
  color: red;
}

.top p {
  margin: 0;
  font-size: 7px;
}

p {
  font-size: 12px;
  margin: 0;
}

p,
span {
  margin: 0;
}

img {
  width: 70px;
  height: 70px;
}

.signature-card {
  border: 1px solid black;
  border-radius: 8px;
  background-color: #f9f9f9;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.signature-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}

@media print {
  section {
    font-size: 13px !important;
  }
  p,
  span {
    font-size: 10px !important;
  }
}

.activity-name {
  font-size: 16px !important;
  font-weight: bold !important;
  padding: 8px 0 !important;
}

.activity-section {
  page-break-inside: avoid;
  break-inside: avoid;
  border-collapse: collapse;
}

.activity-header {
  page-break-inside: avoid;
  break-inside: avoid;
  page-break-after: avoid;
  break-after: avoid;
}

.activity-item {
  page-break-inside: avoid;
  break-inside: avoid;
  margin-bottom: 0;
  border-collapse: collapse;
}

.activity-content {
  page-break-inside: auto;
  break-inside: auto;
  border-collapse: collapse;
}

.activity-section .border,
.activity-section .border-left,
.activity-section .border-right,
.activity-section .border-bottom,
.activity-section .border-top {
  border-collapse: collapse;
  margin: 0;
  padding: 0;
}

.activity-section .row {
  margin: 0;
  border-collapse: collapse;
}

.activity-section span {
  margin: 0;
  padding: 4px 8px;
  box-sizing: border-box;
  border-collapse: collapse;
}

@media print {
  @page {
    margin: 1cm 0.5cm;
    size: A4;
  }
  body {
    margin: 0;
    padding: 0;
  }
  .activity-name {
    font-size: 14px !important;
    font-weight: bold !important;
  }
  .activity-section {
    page-break-inside: avoid;
    border-collapse: collapse;
  }

  .activity-header {
    page-break-after: avoid;
  }

  .activity-item {
    page-break-inside: avoid;
    orphans: 2;
    widows: 2;
    margin-bottom: 0;
    border-collapse: collapse;
  }

  .activity-section .border,
  .activity-section .border-left,
  .activity-section .border-right,
  .activity-section .border-bottom,
  .activity-section .border-top {
    border-collapse: collapse;
    margin: 0;
  }
}

.signature-container {
  page-break-inside: avoid;
  break-inside: avoid;
}

.signature-field {
  min-height: 100px !important;
  height: auto !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}

.signature-img {
  width: 120px !important;
  height: 80px !important;
  object-fit: contain !important;
  image-rendering: -webkit-optimize-contrast !important;
  image-rendering: crisp-edges !important;
  image-rendering: pixelated !important;
}

.signature-text {
  height: 80px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 14px !important;
}

.historico-observacoes-section {
  page-break-inside: avoid;
  break-inside: avoid;
  border-collapse: collapse;
}

.historico-observacoes-header,
.historico-observacoes-table-header {
  page-break-inside: avoid;
  break-inside: avoid;
  page-break-after: avoid;
  break-after: avoid;
  border-collapse: collapse;
}

.historico-observacoes-row {
  page-break-inside: avoid;
  break-inside: avoid;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
}

@media print {
  .historico-observacoes-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    border-collapse: collapse !important;
  }
  .historico-observacoes-header,
  .historico-observacoes-table-header {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
    border-collapse: collapse !important;
  }
  .historico-observacoes-row {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    border-collapse: collapse !important;
    orphans: 2;
    widows: 2;
    margin: 0 !important;
    padding: 0 !important;
  }
}

.pagina-margem {
  margin: 24px;
}

@media print {
  .pagina-margem {
    margin: 1cm !important;
    box-sizing: border-box;
    width: auto !important;
    height: auto !important;
  }
}

@media (max-width: 480px) {
  #base-mobile {
    transform: scale(0.4) !important;
    transform-origin: top left !important;
    width: 250% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}

.assinatura-responsavel-card .signature-img {
  width: 140px !important;
  height: 120px !important;
}
</style>
